// src/pages/Pharmacy/pharmacyTourConfig.js

import i18n from "../../../i18n/config";

export const pharmacyTourSteps = [
	  {
	    popover: {
	      title: i18n.t("tours.pharmacy.welcome"),
	      description: i18n.t("tours.pharmacy.welcomeDesc"),
	      side: "over",
	    },
	  },
	  {
	    element: 'input[placeholder*="Search"]',
	    popover: {
	      title: i18n.t("tours.pharmacy.search"),
	      description: i18n.t("tours.pharmacy.searchDesc"),
	      position: "bottom",
	    },
	  },
	  {
	    element: ".phl-tabs",
	    popover: {
	      title: i18n.t("tours.pharmacy.tabs"),
	      description: i18n.t("tours.pharmacy.tabsDesc"),
	      position: "bottom",
	    },
	  },
	  {
	    element: ".phc-row",
	    popover: {
	      title: i18n.t("tours.pharmacy.list"),
	      description: i18n.t("tours.pharmacy.listDesc"),
	      position: "top",
	    },
	  },
	  {
	    element: ".pharmacy-item",
	    popover: {
	      title: i18n.t("tours.pharmacy.card"),
	      description: i18n.t("tours.pharmacy.cardDesc"),
	      position: "left",
	    },
	  },
	  {
	    popover: {
	      title: i18n.t("tours.pharmacy.done"),
	      description: i18n.t("tours.pharmacy.doneDesc"),
	      side: "over",
	    },
	  },
];